import { useQuery } from '@tanstack/react-query';
import { fancyShareQueryKey } from 'queries/fancyShare/queryKey';
import { FancyShareApi } from 'api/ApiHelper';

export const useGetFancyShareQuery = (fancyShareId: number) =>
  useQuery({
    queryKey: fancyShareQueryKey.fancyShare(fancyShareId),
    queryFn: () => FancyShareApi.getFancyShare(fancyShareId),
  });
